class JPromise extends Promise {
  constructor(...args) {
    super(...args); // 调用父类的constructor

    if (this.__proto__) {
      this.__proto__.fail = this.__proto__.catch;
      this.__proto__.always = this.__proto__.finally;
    }
  }
}

module.exports = JPromise;


// WEBPACK FOOTER //
// ./src/net/promise.js